import React from "react";
import * as fieldComponents from "../Models/Core/FieldComponents";

function CombinedFieldComponent(props) {

    const {
        componentDefinitions,
        fieldDefPrefix = '',
        FieldDefinitionGroups: fieldGroupDefinitions,
    } = props;

    const fieldComponentRenderer = fieldComponentHooks(props);

    const components = componentDefinitions.map((componentDefinition, i) => {

        const {
            component: componentName = "TextFieldViewer",
            fieldKey = null,
            value = null
        } = componentDefinition;

        const fieldDefinition = fieldGroupDefinitions.find(group => (
            group.value.find(field => (
                field.key === (fieldDefPrefix + fieldKey)
            ))
        ));

        return fieldComponentRenderer(componentName, fieldDefinition, value, fieldKey ?? String(i));
    });

    return <div className="sb-combined-field-viewer">{components}</div>;
}

export const fieldComponentHooks = (props) => {

    const {
        FieldDef,
        FieldDefinitionGroups = null,
        SkipBorder,
        Validation,
        RootData,
        Data,
        OnValidationUpdate,
        CustomData,
        IsNewModel,
        DefaultSelectedFieldDefKey,
        tdClassName = '',
        defaultValue = undefined,
        subText = null,
        UpdateField: updateField,
        UpdateFields: updateFields,
    } = props;

    return (componentName = "TextFieldViewer", fieldDefinition = FieldDef, value = null, key = null, fieldDefs = null) => {

        if(componentName instanceof Array) {
            return <CombinedFieldComponent
                {...props}
                fieldDefPrefix={fieldDefinition?.keyPrefix}
                componentDefinitions={componentName}
            />;
        }

        const FieldComponent = fieldComponents?.[componentName] ?? null;

        if(FieldComponent == null) {
            console.log('FieldComponent with name: `' + componentName + '` was not defined.')
            return null;
        }

        return <FieldComponent
            key={key ?? fieldDefinition.key}
            Value={fieldDefinition?.getter?.(Data) ?? value ?? defaultValue}
            OnUpdate={(y, field = fieldDefinition) => updateField?.(field ?? fieldDefinition, y)}
            OnUpdates={y => updateFields?.(y)}
            FieldDef={fieldDefinition}
            RootData={RootData}
            Data={Data}
            FieldDefs={FieldDefinitionGroups ?? fieldDefs}
            OnValidationUpdate={OnValidationUpdate}
            CustomData={CustomData}
            IsNewModel={IsNewModel}
            DefaultSelectedFieldDefKey={DefaultSelectedFieldDefKey}
        />
    }
}
